module.exports = __webpack_public_path__ + "static/weather-web-light-plp-bafcc5e580320ff2a232c9f62140045d.png";